<template lang="jade">
  div.Lightbox(role="dialog"
               class="animated"
               v-bind:class="{'Lightbox--open': open }"
               v-if="open"
               transition="fade")
    spinner(":loading.sync"="loading")
    div.Lightbox__container(v-show="!loading"
                            class="animated"
                            ":style"="{ width: width }"
                            v-el:modal
                            transition="fade")
      header.Lightbox__header
        h2.Lightbox__title {{ title }}
        button.Lightbox__close(type="button"
                               class="Button"
                               @click="close") &times
      slot(name="Lightbox__body")
      //- slot.Lightbox__footer(name="Lightbox__footer")
</template>
<script>
  import spinner from 'src/components/loaders/spinner'

  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      open: {
        require: true,
        type: Boolean,
        twoWay: true
      },
      width: {
        type: String,
        coerce: x => x + 'px',
        default: '100%'
      },
      callback: {
        type: Function
      },
      loading: { type: Boolean, default: true },
      effect: { type: String, default: null },
      backdrop: { type: Boolean, default: true },
      large: { type: Boolean, default: false },
      small: { type: Boolean, default: false }
    },

    data () {
      return {}
    },
    components: {
      spinner
    },
    methods: {
      toggleClickaway (active) {
        setTimeout(() => {
          active ? document.addEventListener('click', this.clickaway)
                 : document.removeEventListener('click', this.clickaway)
        }, 500)
      },

      descendant (parent, node) {
        if (node === null) return false
        return (node === parent) || this.descendant(parent, node.parentNode)
      },

      clickaway (e) {
        let el = this.$els.modal
        let target = e.target
        if ((el !== target) && !this.descendant(el, target)) this.close()
      },

      close () {
        this.$set('open', false)
        this.$dispatch('closed', true)
      }
    },
    watch: {
      'open': 'toggleClickaway'
    }
  }
</script>



// WEBPACK FOOTER //
// lightbox.vue?565d4d06